// extracted by mini-css-extract-plugin
module.exports = {"item":"TodoItem_item__EiNWR"};